import { useEffect, useState } from 'react';
import { SINA_TRUCK_FRAMES, SINA_TRUCK_FRAME_MS } from './sinaTruck.js';

function prefersReducedMotion() {
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}

/** Sina saliendo en camión: indicador de progreso de una acción en curso. */
export default function SinaTruckLoader({ label = 'Cargando', className = '', leaving = false }) {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const timer = window.setInterval(() => setFrame((current) => (current + 1) % SINA_TRUCK_FRAMES.length), SINA_TRUCK_FRAME_MS);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <span className={`sina-truck-loader ${leaving ? 'is-leaving' : ''} ${className}`.trim()} role="status">
      <img src={SINA_TRUCK_FRAMES[frame]} alt="" role="presentation" />
      <span className="sina-truck-loader__label">{label}</span>
    </span>
  );
}
